import { archiveReportAction } from "../actions/archiveReportAction";

import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isArchiveReport: false,
  fetchTableData: false,
  search: {
    physicians: [],
    account: null,
    reportStartDate: null,
    reportEndDate: null,
    lastBillingStartDate: null,
    lastBillingEndDate: null,
    processedStartDate: null,
    processedEndDate: null,
    patient_name: "",
    patient_serial_num: "",
    billable: "",
    reportsOnEvoke: false,
    transmissionType: "",
  },
  searchQuery: "",
  page: 0,
  pageSize: 25,
  filters: [],
  tableFilter: "",
  orderBy: "",
  orderDirection: "asc",
  reports: [],
};

const archiveReportSlice = createSlice({
  name: "archiveReport",
  initialState: initialState,
  reducers: archiveReportAction,
});

export const {
  changePage,
  changePageSize,
  changeReportSearch,
  setSearchQuery,
  changeReportFilters,
  changeReportOrder,
  toogleArchiveReportTableData,
  loadArchivedReports,
  setIsArchiveReport,
} = archiveReportSlice.actions;

export default archiveReportSlice.reducer;
